import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../assets/logo2.png';
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LCAside = _resolveComponent("LCAside");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_LCHearder = _resolveComponent("LCHearder");
  const _component_el_header = _resolveComponent("el-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, {
    style: {
      "margin-top": "-20px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_aside, {
      width: "200px"
    }, {
      default: _withCtx(() => [_cache[0] || (_cache[0] = _createElementVNode("p", {
        style: {
          "display": "flex",
          "justify-content": "center"
        }
      }, [_createElementVNode("img", {
        src: _imports_0,
        style: {
          "width": "18px",
          "height": "18px",
          "margin-right": "2px"
        }
      }), _createElementVNode("span", {
        style: {}
      }, "特检通系统")], -1)), _createVNode(_component_LCAside)]),
      _: 1
    }), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_header, {
        style: {
          "text-align": "right",
          "font-size": "12px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_LCHearder)]),
        _: 1
      }), _createVNode(_component_el_main, {
        class: _normalizeClass($options.key == '/home' ? 'main' : ''),
        style: {}
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_router_view, {
          key: $options.key
        }))]),
        _: 1
      }, 8, ["class"])]),
      _: 1
    })]),
    _: 1
  });
}